import sortByIcon from "../../assets/icons/newsroom/newscard/sortby.svg";
import { useEffect, useState } from "react";
import {
  newsRoomData,
  newsRoomSortingData,
  newsRoomSearchData,
  uploadNews,
  shareDailyEmail,
  shareWeeklyEmail,
  shareFuelEuEmail,
  deleteFuelEuItem,
} from "../../features/NewsRoom/NewsRoomSlice";
import { useDispatch, useSelector } from "react-redux";
import {
  setSelectedNewsData,
  selectedNewsRoomID,
  setSelectedFuelEuData,
  selectedFuelEuRoomID
} from "../../features/NewsRoom/NewsRoomSlice";
import deleteNotificationIcon from "../../assets/icons/notifications/delete.svg";
import { toggleModal, updateModalInfo } from "../../features/App/AppSlice";
import React from "react";
import { Input, Space, DatePicker, Modal, Button, Form, Upload } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { color, style } from "d3";

const { Search } = Input;

const FUEL_EU_DEFAULT_RECIPIENTS = [
  "subham.sinha@azolla.sg",
  "truongdt@tanbinhship.com",
  "technic@chemfleet.org",
  "mehmet@orasshipping.com",
  "nurettin.kayabasi@capramar.com",
  "technical@ommar.com",
  "santosh.mohite@transworld.com",
  "jacob.myre@hansatankers.com",
  "ism@cenkshipping.com",
  "igor.damming@seatrade.nl",
  "nathaji@emaratmaritime.com",
  "himanshu@acetankers.com",
  "clement.vaccarella@trammo.com",
  "harshit.tripathi@ultrabulk.com",
  "Ivan.Ferdinand@jadroplov.com",
  "austin.ajith@atlanship.nl",
  "Mario.SpazianiTesta@augustadue.it",
  "georgios@xtholdings.com",
  "filip.feurst@stenabulk.com",
  "Georgia.SOTIROULI@minoamarine.gr",
  "aoberktas@acechemtanker.com",
  "operations@singunion.com.sg",
  "n.ellwood@jamesfisher.co.uk",
  "commercial@kcmaritime.com",
  "ali@armadorshipping.com",
  "zkleopas@starbulk.com",
  "shailesh@eships.ae",
  "kuldeep.uniyal@gemships.com",
  "ceren.selman@borealisdenizcilik.com",
  "marlin.andersen@gearbulk.com",
  "james@smt.com.sg",
  "nhagewood@afsgroup.nl",
  "naveen.r@cochinshipyard.in",
  "technical@spmshipping.ae",
  "merwynpinto@spmshipping.ae",
  "subothkumar@sishipping.com",
  "mukund@sishipping.com",
  "technical@mantiniashipping.com",
  "mdeslarzes@sgmship.ch",
  "vangelis.rousos@tufton.com",
  "jupji.h@rafflestankers.com",
  "Operations@womarpools.com",
  "Manoj.Kalra@abgtrading.com",
  "mbessone@scorpiogroup.net",
  "operation@yasatanker.com",
  "okl@mbshipbrokers.com",
  "jahj@mshipbrokers.com",
  "chartering@yasatanker.com",
  "raja@mbshipbrokers.com",
  "jackie.smith@lomarshipping.com",
  "Chukwuemeka.Okoye@nsml.com",
  "estela@tmcshipping.com",
  "yetkin.fer@onnshipping.com",
  "ls@falconmaritime.com",
  "bk@falconmaritime.com",
  "selin@gulnak.com",
  "emre@batinak.com",
  "seher@gulport.com",
  "ops@ventsmarins.com",
  "chartering@jns.net.cn",
  "zhuyonghao@jns.net.cn",
  "shipmd@worldm.co.jp",
  "dry@omegaship.gr",
  "tankers@omegaship.gr",
  "operations@orientmarine.com",
  "mail@nissenkaiun.com",
  "ops@eliteships.sg",
  "roy.anilanand@eliteships.sg",
  "rob.phillips@amdlship.com",
  "f.gheblawi@amptc.net",
  "container@lilaglobal.net",
  "nvsubramanyam@kyramarine.com",
  "technical@hermesmaritime.com",
  "sukhwindercapt@hermesmaritime.com",
  "commercial.evalend@softway.gr",
  "kie_hyodo@kitaurakaiun.co.jp",
  "thanh.dq@htkvn.com",
  "tienthanh@tanbinhship.com",
  "hamid.shaat@gulfnav.com",
  "coord@hjmarine.co.jp",
  "operations@swnav.com.tw",
  "main@goodwillmaritime.com",
  "eirik.gjerde@utkilen.no",
  "performance@christianiashipping.com",
  "erik.hjortland@odjfell.com",
  "eed@tsthellas.gr",
  "thomas@veritastankers.se",
  "Olli.Vesanto@langh.fi",
  "burcin.boy@ulusoysealines.com",
  "anders.viiala@tarntank.com",
  "Janne.Eklof@eslshipping.com",
  "Sander.Wilgenhof@neste.com",
  "plamen@ihbshipping.com",
  "g.sivkov@ihbshipping.com",
  "arvind.mohan@anseimaritime.com",
  "djp@fairfieldchemical.com",
  "bmidha@fairchem.sg",
  "vslavchev@naviborn.com",
  "villalon@misugakaiun.co.jp",
  "amr.abdelwahab@transmar.com",
  "mohamed.ahwal@transmar.com",
  "aleksandar.krstic@rubikonsc.com",
  "pierantoniochillo@ctmmc.com",
  "fcanepa@ctmmc.com",
  "osiri@ctmmc.com",
  "leyland.pinto@vallesfleet.com",
  "george.kann@vallesfleet.com",
  "wellington.koo@vallessteamship.com",
  "ram.sharma@vallesfleet.com",
  "knutsen@sealiftinc.com",
  "larry.toth@sealiftinc.com",
  "schroeder@sealiftinc.com",
  "sujinchai@sinokor.co.kr",
  "abhisheks@sinokor.co.in",
  "jhl@sinokor.co.kr",
  "jhchoi@sinokor.co.kr",
  "shyoon@sinokor.co.kr",
  "wburke@carnival.com",
  "eheldewier@carnival.com",
  "mathias.audrain@mnnantes.fr",
  "manon.payet@mnnantes.fr",
  "armand.gamundi@mnnantes.fr",
  "o.julien@socatra.com",
  "k.meulemeester@socatra.com",
  "c.corneloup@socatra.com",
  "marius.szabo@histria.ro",
  "adrian.orasteanu@histria.ro",
  "daniela.marinescu@histria.ro",
  "kainulainen.timo@poferries.com",
  "cmenger@poferries.com",
  "alex.cork@poferries.com",
  "brian.quinn@wincanton.co.uk",
  "leigh.bura@poferries.com",
  "neads.mary@poferries.com",
  "victoria.song@seacon.com",
  "james@seaconstar.com",
  "xiangxin@seaconstar.com",
  "levy.shay@zim.com",
  "hod.benny@zim.com",
  "christophe.seguinot@lameridionale.fr",
  "pierrick.delaunay@lameridionale.fr",
  "fabrice.turquet@brittanyferries.fr",
  "grace.liang@oocl.com",
  "kenny.ye@oocl.com",
  "gavin.murdoch@oocl.com",
  "huyen.t.t.nguyen@oocllogistics.com",
  "kristen@concordm.com",
  "benoist.grosjean@sogestranshipping.com",
  "pierre.cossart@sogestran.com",
  "charbel.khoueiry@sallaumlines.com",
  "oal@laskmar.com",
  "py@primebulk.com",
  "mt@primebulk.com",
  "ak@primebulk.com",
  "grensemann@kreyschiffahrt.de",
  "babenko@kreyschiffahrt.de",
  "m.krella@smtshipping.com",
  "p.eagles@smtshipping.com",
  "j.egan@smtshipping.com",
  "s.vestergaard@smtshipping.com",
  "florisjan.sturing@seatrade.nl",
  "mark.jansen@seatrade.nl",
  "pablo.gonzalez@seatrade.com",
  "ron.van.der.born@seatrade.global",
  "am@ooc.com.cy",
  "patrick.schwinke@zeaship.com",
  "sebastian.kutz@zeaship.com",
  "katja.schreier@zeaship.com",
  "luz@zeaship.com",
  "nina.bjerkely@wilhelmsen.com",
  "alex.skaugen@wilhelmsen.com",
  "silje.skullerud@wilhelmsen.com",
  "gritsopoulos@hammoniareederei.de",
  "schwarz@hammoniareederei.de",
  "hett@hammoniareederei.de",
  "peter.rubinstein@wisbytankers.se",
  "stefan.dombrowsky@wisbytankers.se",
  "per.tillaeus@wisbytankers.se",
  "smt@asl.ie",
  "ps@arklowshipping.nl",
  "dennis.tamke@tamkeship.com",
  "bryan.dubose@rollgroup.com",
  "louis.martel@cslships.com",
  "frank.dahan@cslships.com",
  "frederic.jauvin@cslships.com",
  "daniel.wilson@cslships.com",
  "vinay.singh@eastaway.com",
  "kannan.kanamarlapudi@eastaway.com",
  "l.visser@vissershipping.nl",
  "d.visser@vissershipping.nl",
  "nico.peters@tailwindshipping.com",
  "gerrit.krause@tailwindshipping.com",
  "alexander.prahl@tailwindshipping.com",
  "adrian.ludwig@tailwindshipping.com",
  "david.harrop@fjordline.com",
  "michael.sorensen@fjordline.com",
  "kyrre.andresen@fjordline.com",
  "jan.hauge@fjordline.com",
  "alexander.walster@navigatorgas.com",
  "soren.vilhelmsen@navigatorgas.com",
  "bartosz.kuniewicz@navigatorgas.com",
  "jan.dalm@tarbit.com",
  "johan.bostrom@tarbit.com",
  "mdo@albatankers.com",
  "lky@albatankers.com",
  "hka@vesthimmerland.dk",
  "jol@albatankers.com",
  "kkerssemakers@anthonyveder.com",
  "pmcguire@hollandamericagroup.com",
  "georgef@marinetrans.com",
  "chrisc@marinetrans.com",
  "wieske@slomanneptun.com",
  "drougkas@slomanneptun.com",
  "linck@slomanneptun.com",
  "bartal@smyrilline.fo",
  "gunnar@cargo.fo",
  "simon.tomwoerden@navalis.com",
  "christian.behrmann@navalis.com",
  "itay@asmmaritime.com",
  "andrejmarine@asmmaritime.com",
  "amir@sutherlandglobal.com",
  "kenneth.macleod@songa.co.uk",
  "tina.doescher@essberger.biz",
  "johan.isaksen@essberger.biz",
  "mike.dobson@matrixmarinegroup.com",
  "geoff.ramsay@matrixmarinegroup.com",
  "gzikos@costamare.com",
  "y.fasoulis@costamare.com",
  "plund@costamare.com",
  "kz@costamare.com",
  "dimitris@danaosshipping.gr",
  "vassilis@danaosshipping.gr",
  "cptevangelos@danaos.com",
  "hans.kroon@wagenborg.com",
  "i.sovershaeva@spliethoff.nl",
  "rva@onego.nl",
  "aps@onego.nl",
  "msmith@tankers.uk.com",
  "jlee@tankers.uk.com",
  "stang@fairmontshipping.com",
  "gcheng@fairmontshipping.com",
  "ghuman@fairmontshipping.com",
  "ramaras@fairmontshipping.com",
  "astengo.fulvio@lda.fr",
  "thibault.droguet@lda.fr",
  "gael.cailleaux@lda.fr",
  "guillaume.prenot@lda.fr",
  "alban.billaud@lda.fr",
  "prasad@worldtanker.com.sg",
  "sunil@worldtanker.com.sg",
  "jdowsett@gencoshipping.com",
  "morr@gencoshipping.com",
  "brian.levring@gencoshipping.com",
  "raycheng@parakougroup.com",
  "raymondqiao@parakougroup.com",
  "olivelin@parakougroup.com",
  "johnlau@parakougroup.com",
  "hanne.werquin@exmar.be",
  "kristof.coppe@exmar.be",
  "jenellef@expeditions.com",
  "mwolters@hanzevast.nl",
  "rkanters@hanzevast.nl",
  "dan@semperonsystems.com",
  "lzhang@fmcny.com",
  "kkuo@fmcny.com",
  "set@solvtrans.no",
  "bent@solvtrans.no",
  "robin.halsebakk@solvtrans.no",
  "roger@solvtrans.no",
  "olav.meling@ohmeling.no",
  "roar.misje@griegstar.com",
  "n.grotz@chemship.com",
  "w.boverhof@chemship.com",
  "m.marelis@chemship.com",
  "mgsong@cidoship.com",
  "shchoi@cidoship.com",
  "jan.develd@navquim.com",
  "p.dincq@contilines.be",
  "j.hooyberghs@contilines.be",
  "j.puig@contilines.be",
  "akeller@atlanship.eu",
  "f.diepeveen@forestwave.nl",
  "sytze.gaastra@forestwave.nl",
  "ric.nijhout@forestwave.nl",
  "bjoern.sprotte@bsshipmanagement.com",
  "michael.kazantjis@bsshipmanagement.com",
  "kenneth.bjoerklund@wilhelmsen.com",
  "mikael.lindholm@finnlines.com",
  "perhermod.rasmussen@hurtigruten.com",
  "sdevries@bontrup.ae",
  "bbontrup@bontrup.com",
  "kjensen@canfornav.com",
  "jplate@canfornav.com",
  "emichael@cfngroup.net",
  "callen@canfornav.com",
  "nlorenzen@canfornav.com",
  "oyvind@cargow.com",
  "ragnar@cargow.com",
  "arjenvandamme@clearwatergroup.nl",
  "savodobrisa@clearwatergroup.nl",
  "a.grigoriev@dctshipping.org",
  "anzar@dolphinkuwait.com",
  "rohit@dolphinkuwait.com",
  "rjdupuis@jrshipping.com",
  "rgillespie@jrshipping.com",
  "srust@jrshipping.com",
  "dscheder@macship.com",
  "charis.hansen@macship.com",
  "jroelevink@mfgroup.nl",
  "pdrenth@mfgroup.nl",
  "mh@minship.com",
  "kinburgsergey@minship.com",
  "james.mcconachie@minship.com",
  "volker.arends@minship.com",
  "jhoogerhuis@navis.nu",
  "tosinga@navis.nu",
  "william.fics@neushipping.com",
  "neels.hobbie@neusee.com",
  "kyrylo.davydenko@neusee.com",
  "rslotin@notus.mt",
  "jze@unifeeder.com",
  "rajeev@tolanigroup.com",
  "manish@jaldhi.com",
  "ape@dockendale.net",
  "srelan@pacificbasin.com",
  "ggerapetritis@navios.com",
  "ship@graceoceanship.com",
  "pxagoraris@avin.gr",
  "coo@danaos.com",
  "srinjoy.dasgupta@fleetship.com",
  "oistein.jensen@odfjell.com",
  "smassenhove@bontrup.ae",
  "neel@misugashipm.co.jp",
  "alan.donnelly@cslships.com",
  "Shashank.Ajmani@mtmsm.com",
  "panayiotis.hannas@serenityship.com",
  "a.vatan@yasatanker.com",
  "Serkan.Celik@mantaship.com",
  "j.komers@polferries.pl",
  "c.wittenberg@smtshipping.com",
  "kirsi.ylarinne@eslshipping.com",
  "steinar.spinnangr@uecc.com",
  "serdal@akarshipping.com",
  "info@ymntankers.com.tr",
  "info@mercanshipping.com",
  "kships@kships.com",
  "akoclu@sparkshipping.com.tr",
  "demirhan.g@deval.com",
  "aykin.sargin@springmarines.com",
  "hseq@bbcchartering.com",
  "mja@womarpools.com",
  "operation@aslandenizcilik.com.tr",
  "damithas@cdl.lk",
];

const NewsCard = ({ layout = "default" }) => {
  const { status, newsList = [], selectedNewsID, fuelEuList = [], selectedFuelEuID } = useSelector(
    (state) => state.newsroom
  );
  const { user } = useSelector((state) => state.user);

  const isAdmin =
    user?.is_admin === true || user?.role?.toLowerCase() === "admin";

  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [modalVisible, setModalVisible] = useState(false);
  const [remainingWords, setRemainingWords] = useState(2000);
  const [sortDir, setSortDir] = useState(null);
  const [extraSections, setExtraSections] = useState([]);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [dailyModalVisible, setDailyModalVisible] = useState(false);
  const [weeklyModalVisible, setWeeklyModalVisible] = useState(false);
  const [fuelEUModalVisible, setFuelEUModalVisible] = useState(false);

  const addExtraSection = () =>
    setExtraSections((prev) => [...prev, { title: "", description: "" }]);
  const removeExtraSection = (idx) =>
    setExtraSections((prev) => prev.filter((_, i) => i !== idx));
  const updateExtraSection = (idx, field, value) =>
    setExtraSections((prev) =>
      prev.map((s, i) => (i === idx ? { ...s, [field]: value } : s))
    );


  useEffect(() => {
    if (status === "idle") {
      dispatch(newsRoomData()).then((result) => {
        if (result.payload?.length) {
          dispatch(setSelectedNewsData(result.payload[0]));
          dispatch(selectedNewsRoomID(result.payload[0].id));
        }
      });
    }
  }, [dispatch, status]);

  const months = [
    "January","February","March","April","May","June",
    "July","August","September","October","November","December"
  ];

  const newsData = newsList.map((news) => ({
    id: news.id,
    newsImg: news.thumbnail_url,
    heading: news.title,
    content: news.description,
    date: `${new Date(news.publish_date).getDate()}, ${
      months[new Date(news.publish_date).getMonth()]
    } ${new Date(news.publish_date).getFullYear()}`,
    published_by: news.publish_by
  }));


  const newsClickHandler = (news_id) => {
    const selected = newsList.find((v) => v.id === news_id);
    if (selected) {
      dispatch(setSelectedNewsData(selected));
      dispatch(selectedNewsRoomID(news_id));
    }
  };

  const fuelEuCardData = fuelEuList.map((item) => ({
    id: item.id,
    newsImg: item.thumbnail_url,
    heading: item.title,
    excerpt: (item.description || ""),
    date: `${new Date(item.publish_date).getDate()}, ${
      months[new Date(item.publish_date).getMonth()]
    } ${new Date(item.publish_date).getFullYear()}`,
    published_by: item.publish_by
  }));

  const fuelEuClickHandler = (item_id) => {
    const selected = fuelEuList.find((v) => v.id === item_id);
    if (selected) {
      dispatch(setSelectedFuelEuData(selected));
      dispatch(selectedFuelEuRoomID(item_id));
    }
  };

  const fuelEuDeleteHandler = (item_id) => {
    Modal.confirm({
      title: "Delete this update?",
      content: "This will permanently remove this FuelEU update.",
      okText: "Yes, Delete",
      okButtonProps: { danger: true },
      cancelText: "Cancel",
      onOk: () => {
        dispatch(deleteFuelEuItem(item_id)).then((result) => {
          dispatch(updateModalInfo({
            show: true,
            result: result.payload && !result.error
              ? "FuelEU update deleted successfully!"
              : "Failed to delete FuelEU update.",
            type: result.payload && !result.error ? "success" : "error",
            message: result.payload && !result.error ? "Success!" : "Failed"
          }));
        });
      },
    });
  };

  const newsSortingClickHandler = () => {
    const next = sortDir === 'asc' ? 'desc' : 'asc';
    setSortDir(next);
    dispatch(newsRoomSortingData(next));
  };

  const onSearch = (e) => {
    const val = e.target.value.trim();
    if (val.length >= 3) {
      dispatch(newsRoomSearchData(val)).then((result) => {
        if (result.payload) dispatch(setSelectedNewsData(null));
      });
    } else {
      dispatch(newsRoomData());
    }
  };

  const openModal = () => {
    form.resetFields();
    setExtraSections([]);
    setModalVisible(true);
  };

  const handleSubmit = async (values) => {
    const { title, description, publishDate, thumbnail } = values;
    const thumbnailFile = thumbnail?.[0]?.originFileObj;

    const formData = new FormData();
    formData.append("title", title);
    formData.append("description", description);
    formData.append("publish_date", publishDate.format("YYYY-MM-DD"));
    if (thumbnailFile) formData.append("thumbnail_file", thumbnailFile);
    const sectionData = extraSections
      .filter((sec) => sec.title || sec.description)
      .map((sec) => ({ title: sec.title, description: sec.description }));
    formData.append("section_data", JSON.stringify(sectionData));

    dispatch(uploadNews(formData))
      .then((result) => {
        dispatch(toggleModal());
        dispatch(updateModalInfo({
          show: true,
          result: result.payload
            ? "News Posted Successfully!"
            : "News Post Failed!",
          type: result.payload ? "success" : "error",
          message: result.payload ? "Success!" : "Failed"
        }));

        if (result.payload) dispatch(newsRoomData());
      })
      .catch((error) => {
        dispatch(updateModalInfo({
          show: true,
          result: error.toString(),
          type: "error",
          message: "Failed"
        }));
      });

    setModalVisible(false);
  };

  const handleDescriptionChange = (e) => {
    const words = e.target.value.trim().split(/\s+/);
    setRemainingWords(Math.max(0, 2000 - words.length));
  };

  const validateWordCount = (value = "", maxWords) => {
    const wordCount = value.trim().split(/\s+/).length;
    return wordCount > maxWords
      ? Promise.reject(`Description must not exceed ${maxWords} words`)
      : Promise.resolve();
  };

 

  if (layout === "sidebar") {
    return (
      <div className="nm-sidebar-section">

        {/* TITLE */}
       <div
  style={{
    position: "sticky",
    top: 0,
    background: "#fff",
    padding: "20px 0 20px 0",
    zIndex: 10,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
  }}
>
  <h2 className="nm-section-title" style={{ margin: 0 }}>
    Latest News & Updates
  </h2>

  <div style={{ display:"flex", alignItems:"center", gap:"8px" }}>
    {isAdmin && (
      <div style={{ position:"relative" }}>
        <button onClick={() => setDropdownOpen(p => !p)}
          style={{ height:"32px", padding:"4px 12px", background:"#f1f5f9", border:"1px solid #e2e8f0", borderRadius:"6px", fontSize:"13px", fontWeight:500, color:"#475569", cursor:"pointer", display:"flex", alignItems:"center", gap:"5px", whiteSpace:"nowrap" }}>
          + Updates <span style={{ fontSize:"10px" }}>▼</span>
        </button>
        {dropdownOpen && (<>
          <div style={{ position:"fixed", inset:0, zIndex:99 }} onClick={() => setDropdownOpen(false)} />
          <div style={{ position:"absolute", top:"calc(100% + 6px)", right:0, background:"#fff", border:"1px solid #e2e8f0", borderRadius:"8px", boxShadow:"0 4px 16px rgba(0,0,0,0.10)", minWidth:"160px", zIndex:100, overflow:"hidden" }}>
            {[
              { label:"📅 Daily Update",  action:() => { setDailyModalVisible(true);  setDropdownOpen(false); }},
              { label:"📆 Weekly Update", action:() => { setWeeklyModalVisible(true); setDropdownOpen(false); }},
            ].map(item => (
              <div key={item.label} onClick={item.action}
                style={{ padding:"10px 16px", fontSize:"0.83rem", fontWeight:500, color:"#0f172a", cursor:"pointer" }}
                onMouseEnter={e => e.currentTarget.style.background="#f0fdf9"}
                onMouseLeave={e => e.currentTarget.style.background="transparent"}>
                {item.label}
              </div>
            ))}
          </div>
        </>)}
      </div>
    )}
    {isAdmin && (
      <span className="genericButton" style={{ cursor:"pointer", whiteSpace:"nowrap" }} onClick={openModal}>
        Publish
      </span>
    )}
  </div>
</div>

        {/* SEARCH + UPLOAD + SORT (SAME LINE BELOW TITLE) */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            marginBottom: "15px"
          }}
        >
          <Search
            placeholder="Search News"
            onChange={onSearch}
            style={{ flex: 1 }}
          />

      

          <div
            onClick={newsSortingClickHandler}
            style={{
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: "5px",
              whiteSpace: "nowrap"
            }}
          >
            <span style={{ fontSize: "0.85rem", color: "black" }}>Sort {sortDir === 'asc' ? '↑' : sortDir === 'desc' ? '↓' : '↕'}</span>
          </div>
        </div>

        {/* NEWS LIST */}
        {newsData.map((news) => (
          <div
            key={news.id}
            className={`nm-news-item${
              news.id === selectedNewsID ? " nm-news-item--active" : ""
            }`}
            onClick={() => newsClickHandler(news.id)}
          >
            <div className="nm-news-date">{news.date}</div>
            <div className="nm-news-title">{news.heading}</div>
            <div
              className="nm-news-excerpt"
              dangerouslySetInnerHTML={{
                __html: news.content.slice(0, 200) + "..."
              }}
            />
          </div>
        ))}

        <UploadModal
          open={modalVisible}
          onCancel={() => setModalVisible(false)}
          form={form}
          handleSubmit={handleSubmit}
          handleDescriptionChange={handleDescriptionChange}
          validateWordCount={validateWordCount}
          remainingWords={remainingWords}
          extraSections={extraSections}
          addExtraSection={addExtraSection}
          removeExtraSection={removeExtraSection}
          updateExtraSection={updateExtraSection}
        />

        {dailyModalVisible  && <DailyModal  onClose={() => setDailyModalVisible(false)}  dispatch={dispatch} />}
        {weeklyModalVisible && <WeeklyModal onClose={() => setWeeklyModalVisible(false)} dispatch={dispatch} />}
        {fuelEUModalVisible && <FuelEUModal onClose={() => setFuelEUModalVisible(false)} dispatch={dispatch} />}

      </div>
    );
  }


   if (layout === "sidebar1") {
    return (
      <div className="nm-sidebar-section">

        {/* TITLE */}
       <div
  style={{
    position: "sticky",
    top: 0,
    background: "#fff",
    padding: "20px 0 20px 0",
    zIndex: 10,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
  }}
>
  <h2 className="nm-section-title" style={{ margin: 0 }}>
    Latest News & Updates
  </h2>

  <div style={{ display:"flex", alignItems:"center", gap:"8px" }}>
    {isAdmin && (
      <div style={{ position:"relative" }}>
        <button onClick={() => setDropdownOpen(p => !p)}
          style={{ height:"32px", padding:"4px 12px", background:"#f1f5f9", border:"1px solid #e2e8f0", borderRadius:"6px", fontSize:"13px", fontWeight:500, color:"#475569", cursor:"pointer", display:"flex", alignItems:"center", gap:"5px", whiteSpace:"nowrap" }}>
          + Updates <span style={{ fontSize:"10px" }}>▼</span>
        </button>
        {dropdownOpen && (<>
          <div style={{ position:"fixed", inset:0, zIndex:99 }} onClick={() => setDropdownOpen(false)} />
          <div style={{ position:"absolute", top:"calc(100% + 6px)", right:0, background:"#fff", border:"1px solid #e2e8f0", borderRadius:"8px", boxShadow:"0 4px 16px rgba(0,0,0,0.10)", minWidth:"160px", zIndex:100, overflow:"hidden" }}>
            {[
              { label:"⛽ Fuel EU Update", action:() => { setFuelEUModalVisible(true); setDropdownOpen(false); }},
            ].map(item => (
              <div key={item.label} onClick={item.action}
                style={{ padding:"10px 16px", fontSize:"0.83rem", fontWeight:500, color:"#0f172a", cursor:"pointer" }}
                onMouseEnter={e => e.currentTarget.style.background="#f0fdf9"}
                onMouseLeave={e => e.currentTarget.style.background="transparent"}>
                {item.label}
              </div>
            ))}
          </div>
        </>)}
      </div>
    )}
    
  </div>
</div>

        {/* FUEL EU LIST */}
        {fuelEuCardData.map((item) => (
          <div
            key={item.id}
            className={`nm-news-item${
              item.id === selectedFuelEuID ? " nm-news-item--active" : ""
            }`}
            onClick={() => fuelEuClickHandler(item.id)}
          >
            <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: "8px" }}>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div className="nm-news-date">{item.date}</div>
                <div className="nm-news-title">{item.heading}</div>
              </div>
              {isAdmin && (
                <img
                  src={deleteNotificationIcon}
                  alt="delete"
                  title="Delete update"
                  onClick={(e) => {
                    e.stopPropagation();
                    fuelEuDeleteHandler(item.id);
                  }}
                  style={{ cursor: "pointer", width: "16px", height: "16px", opacity: 0.6, flexShrink: 0, marginTop: "2px" }}
                />
              )}
            </div>
            <div className="nm-news-excerpt">
              {item.excerpt.slice(0, 200)}
              {item.excerpt.length > 200 ? "..." : ""}
            </div>
          </div>
        ))}

        <UploadModal
          open={modalVisible}
          onCancel={() => setModalVisible(false)}
          form={form}
          handleSubmit={handleSubmit}
          handleDescriptionChange={handleDescriptionChange}
          validateWordCount={validateWordCount}
          remainingWords={remainingWords}
          extraSections={extraSections}
          addExtraSection={addExtraSection}
          removeExtraSection={removeExtraSection}
          updateExtraSection={updateExtraSection}
        />

        {dailyModalVisible  && <DailyModal  onClose={() => setDailyModalVisible(false)}  dispatch={dispatch} />}
        {weeklyModalVisible && <WeeklyModal onClose={() => setWeeklyModalVisible(false)} dispatch={dispatch} />}
        {fuelEUModalVisible && <FuelEUModal onClose={() => setFuelEUModalVisible(false)} dispatch={dispatch} />}

      </div>
    );
  }
 
  return (
    <div className="nm-newscard-wrapper">
      <div className="newsCard-Elem1">
        <div
          className="newCard-Elem1-btn-sort"
          style={{ display: "flex", gap: "0.75rem" }}
        >
          <Space>
            <Search
              placeholder="Search News"
              onChange={onSearch}
              style={{ width: 220 }}
            />
          </Space>

          {isAdmin && (
            <span className="genericButton" onClick={openModal}>
              Upload News
            </span>
          )}

          <div
            onClick={newsSortingClickHandler}
            className="newsCard-Elem1-SortBy"
          >
            <p>Sort {sortDir === 'asc' ? '↑' : sortDir === 'desc' ? '↓' : '↕'}</p>
          </div>
        </div>
      </div>

      <div className="newsCard-Elem2">
        {newsData.map((news) => (
          <div
            key={news.id}
            onClick={() => newsClickHandler(news.id)}
            className={
              news.id === selectedNewsID
                ? "newsCard-Elem2-Card newsCard-Elem2-Card-active"
                : "newsCard-Elem2-Card"
            }
          >
            <div className="newsCard-Elem2-Image">
              <img src={news.newsImg} alt="news" />
            </div>
            <div className="newsCard-Elem2-Content">
              <h1>{news.heading}</h1>
              <div dangerouslySetInnerHTML={{ __html: news.content }} />
              <div>
                <p>{news.date}</p>
                <p>{news.published_by}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      <UploadModal
        open={modalVisible}
        onCancel={() => setModalVisible(false)}
        form={form}
        handleSubmit={handleSubmit}
        handleDescriptionChange={handleDescriptionChange}
        validateWordCount={validateWordCount}
        remainingWords={remainingWords}
        extraSections={extraSections}
        addExtraSection={addExtraSection}
        removeExtraSection={removeExtraSection}
        updateExtraSection={updateExtraSection}
      />
    </div>
  );
};


const UploadModal = ({
  open,
  onCancel,
  form,
  handleSubmit,
  handleDescriptionChange,
  validateWordCount,
  remainingWords,
  extraSections = [],
  addExtraSection,
  removeExtraSection,
  updateExtraSection
}) => (
  <Modal
    title={<span style={{ fontSize: "1.05rem", fontWeight: 700, color: "#0d1117" }}>Upload News</span>}
    open={open}
    onCancel={onCancel}
    footer={null}
    className="uploadNewsModal"
    width={620}
    styles={{ body: { maxHeight: "75vh", overflowY: "auto", padding: "20px 24px" } }}
  >
    <Form layout="vertical" form={form} onFinish={handleSubmit}>

      {/* Title + Date row */}
      <div style={{ display: "grid", gap: "12px", marginBottom: "12px", width: "100%" }}>
        <Form.Item
          name="title"
          label={<span style={{ fontWeight: 600, fontSize: "0.82rem", color: "#374151" }}>Title</span>}
          rules={[{ required: true, message: "Please input the title" }]}
          style={{ flex: 1, marginBottom: 0 }}
        >
          <Input placeholder="Title" style={{ borderRadius: "7px" , width: "100%", fontWeight: 300}} />
        </Form.Item>
       
      </div>

      {/* Description */}
      <Form.Item
        name="description"
        label={<span style={{ fontWeight: 600, fontSize: "0.82rem", color: "#374151" }}>Description</span>}
        rules={[
          { required: true, message: "Please input the description" },
          { validator: (_, value) => validateWordCount(value, 2000) }
        ]}
        style={{ marginBottom: "4px" }}
      >
        <Input.TextArea
          onChange={handleDescriptionChange}
          placeholder="Description"
          autoSize={{ minRows: 4, maxRows: 7 }}
          style={{ borderRadius: "7px", resize: "none" , width: "100%"}}
        />
      </Form.Item>
      <div style={{ fontSize: "0.73rem", color: remainingWords < 100 ? "#dc2626" : "#9ca3af", textAlign: "right", marginBottom: "12px" }}>
        {remainingWords} / 2000 words remaining
      </div>

      {/* Extra Sections */}
      {extraSections.length > 0 && (
        <div style={{ display: "flex", flexDirection: "column", gap: "10px", marginBottom: "10px" }}>
          {extraSections.map((sec, idx) => (
            <div
              key={idx}
              style={{
                border: "1px solid #e2e8f0",
                borderLeft: "3px solid #0a8f7a",
                borderRadius: "8px",
                padding: "12px 14px",
                background: "#f8fafc"
              }}
            >
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px" }}>
                <span style={{ fontSize: "0.7rem", fontWeight: 700, color: "#0a8f7a", textTransform: "uppercase", letterSpacing: "0.6px" }}>
                Extra Section 
                </span>
                <button
                  type="button"
                  onClick={() => removeExtraSection(idx)}
                  style={{ background: "none", border: "none", cursor: "pointer", fontSize: "0.75rem", color: "#9ca3af", padding: "2px 6px", borderRadius: "4px" }}
                  onMouseEnter={e => e.currentTarget.style.color = "#dc2626"}
                  onMouseLeave={e => e.currentTarget.style.color = "#9ca3af"}
                >
                  ✕ Remove
                </button>
              </div>
              <div style={{ display: "grid", gridTemplateRows: "1fr 1fr", gap: "8px" }}>
                <Input
                  placeholder="Title"
                  value={sec.title}
                  onChange={(e) => updateExtraSection(idx, "title", e.target.value)}
                  style={{ borderRadius: "6px", fontWeight: 500, width: "100%", display: "block" }}
                />
                <Input.TextArea
                  placeholder="Description"
                  value={sec.description}
                  onChange={(e) => updateExtraSection(idx, "description", e.target.value)}
                  autoSize={{ minRows: 2, maxRows: 5 }}
                  style={{ borderRadius: "6px", resize: "none", width: "100%", display: "block" }}
                />
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Add Section button */}
      <button
        type="button"
        onClick={addExtraSection}
        style={{
          display: "flex", alignItems: "center", justifyContent: "center", gap: "6px",
          width: "100%", marginBottom: "14px", padding: "7px 12px",
          background: "transparent", border: "1.5px dashed #0a8f7a",
          borderRadius: "8px", color: "#0a8f7a", fontSize: "0.82rem",
          fontWeight: 600, cursor: "pointer"
        }}
        onMouseEnter={e => e.currentTarget.style.background = "#f0fdf9"}
        onMouseLeave={e => e.currentTarget.style.background = "transparent"}
      >
        <span style={{ fontSize: "1rem", lineHeight: 1 }}>+</span> Add Section
      </button>

      {/* Thumbnail */}
        <div style={{display: "grid", gridTemplateColumns: "1fr 1fr", gap: "85px"}}>
       <Form.Item
          name="publishDate"
          label={<span style={{ fontWeight: 600, fontSize: "0.82rem", color: "#374151" }}>Publish Date</span>}
          rules={[{ required: true, message: "Please select the publish date" }]}
          style={{ width: "155px", marginBottom: 0 }}
        >
          <DatePicker style={{ width: "219px", borderRadius: "7px", height: "32px" }} />
        </Form.Item>
      <Form.Item
        name="thumbnail"
        label={<span style={{ fontWeight: 600, fontSize: "0.82rem", color: "#374151" }}>Thumbnail</span>}
        valuePropName="fileList"
        getValueFromEvent={(e) => Array.isArray(e) ? e : e?.fileList}
        rules={[{ required: true, message: "Please upload the thumbnail" }]}
        style={{ marginBottom: "16px" }}
      >
        <Upload beforeUpload={() => false} listType="picture">
          <Button icon={<UploadOutlined />} style={{ borderRadius: "7px", color: "#8080808c " }}>
            Click to upload thumbnail
          </Button>
        </Upload>
      </Form.Item>
        </div>
      {/* Submit */}
      <Form.Item style={{ marginBottom: 0 }}>
        <Button
          type="primary"
          htmlType="submit"
          style={{ width: "100%", height: "38px", borderRadius: "8px", background: "#0a8f7a", borderColor: "#0a8f7a", fontWeight: 600, fontSize: "0.9rem", marginTop: "12px" }}
        >
          Publish Article
        </Button>
      </Form.Item>

    </Form>
  </Modal>
);

const SALUTATION_DEFAULT = `Dear Valued Client,

We hope this message finds you well. Please find below your latest carbon market update from the Azolla team.`;

const azCss = `
  @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600&family=DM+Mono:wght@400;500&display=swap');
  .az-overlay{position:fixed;inset:0;background:rgba(10,18,30,0.72);backdrop-filter:blur(6px);display:flex;align-items:center;justify-content:center;z-index:2000;padding:20px;animation:azFadeIn 0.2s ease;}
  @keyframes azFadeIn{from{opacity:0}to{opacity:1}}
  .az-modal{background:#ffffff;border-radius:16px;width:100%;max-width:620px;max-height:92vh;overflow-y:auto;box-shadow:0 32px 80px rgba(10,18,30,0.28),0 0 0 1px rgba(29,53,87,0.08);animation:azSlideUp 0.25s cubic-bezier(.22,.68,0,1.2);font-family:'DM Sans',sans-serif;}
  @keyframes azSlideUp{from{transform:translateY(24px);opacity:0}to{transform:translateY(0);opacity:1}}
  .az-modal-header{padding:28px 32px 20px;border-bottom:1px solid #eef1f6;display:flex;align-items:flex-start;justify-content:space-between;position:sticky;top:0;background:#fff;z-index:2;border-radius:16px 16px 0 0;}
  .az-modal-badge{display:inline-flex;align-items:center;gap:7px;font-size:10px;letter-spacing:2px;text-transform:uppercase;font-weight:600;color:#1d3557;background:#eef3f8;padding:5px 10px;border-radius:6px;margin-bottom:8px;}
  .az-modal-badge-weekly{color:#0e6b5e;background:#e6f4f1;}
  .az-modal-title{font-size:20px;font-weight:600;color:#0d1f33;letter-spacing:-0.4px;}
  .az-modal-subtitle{font-size:13px;color:#8fa3b8;margin-top:3px;}
  .az-close{width:32px;height:32px;border-radius:8px;border:1px solid #e4eaf2;background:none;cursor:pointer;font-size:16px;color:#8fa3b8;display:flex;align-items:center;justify-content:center;transition:all 0.15s;flex-shrink:0;margin-top:4px;}
  .az-close:hover{background:#f4f7fb;color:#1d3557;}
  .az-modal-body{padding:24px 32px 28px;display:flex;flex-direction:column;gap:20px;}
  .az-section-divider{font-size:10px;letter-spacing:2px;text-transform:uppercase;font-weight:600;color:#8fa3b8;display:flex;align-items:center;gap:10px;margin:4px 0 -4px;}
  .az-section-divider::after{content:'';flex:1;height:1px;background:#eef1f6;}
  .az-field{display:flex;flex-direction:column;gap:6px;}
  .az-field-row{display:grid;grid-template-columns:1fr 1fr;gap:14px;}
  .az-label{font-size:12px;font-weight:500;color:#3d5166;letter-spacing:0.2px;display:flex;align-items:center;gap:5px;}
  .az-label span{color:#e05c5c;}
  .az-input,.az-textarea{width:100%;padding:10px 13px;border:1.5px solid #d4dbe6;border-radius:9px;font-size:13.5px;color:#0d1f33;font-family:'DM Sans',sans-serif;outline:none;transition:border-color 0.15s,box-shadow 0.15s;background:#fafbfd;}
  .az-input:focus,.az-textarea:focus{border-color:#1d3557;box-shadow:0 0 0 3px rgba(29,53,87,0.08);background:#fff;}
  .az-textarea{resize:vertical;min-height:80px;line-height:1.6;}
  .az-price-grid,.az-price-grid-3{display:grid;grid-template-columns:repeat(4,1fr);gap:10px;}
  .az-price-card{background:#f4f7fb;border:1.5px solid #e4eaf2;border-radius:10px;padding:12px 10px;text-align:center;}
  .az-price-card-label{font-size:9px;letter-spacing:1.5px;text-transform:uppercase;color:#8fa3b8;margin-bottom:6px;}
  .az-price-card input{width:100%;background:none;border:none;outline:none;font-size:17px;font-weight:700;color:#1d3557;text-align:center;font-family:'DM Mono',monospace;letter-spacing:-0.5px;}
  .az-price-card input::placeholder{color:#c0ccd8;font-weight:400;}
  .az-price-eur{font-size:9px;color:#8fa3b8;margin-top:2px;}
  .az-recipients{display:flex;flex-direction:column;gap:8px;}
  .az-recipient-row{display:flex;gap:8px;align-items:center;}
  .az-recipient-row .az-input{flex:1;}
  .az-remove-btn{width:32px;height:38px;border:1.5px solid #e4eaf2;border-radius:8px;background:none;cursor:pointer;color:#8fa3b8;font-size:16px;display:flex;align-items:center;justify-content:center;transition:all 0.15s;flex-shrink:0;}
  .az-remove-btn:hover{background:#fff0f0;border-color:#f5c6c6;color:#e05c5c;}
  .az-add-recipient{font-size:12.5px;color:#1d3557;font-weight:500;cursor:pointer;display:inline-flex;align-items:center;gap:5px;background:none;border:1.5px dashed #c5d0de;border-radius:8px;padding:8px 14px;transition:all 0.15s;width:100%;justify-content:center;}
  .az-add-recipient:hover{background:#f4f7fb;border-color:#1d3557;}
  .az-section-block{border:1.5px solid #e4eaf2;border-radius:12px;overflow:hidden;}
  .az-section-block-header{background:#f4f7fb;padding:10px 16px;display:flex;align-items:center;justify-content:space-between;}
  .az-section-block-title{font-size:11px;font-weight:600;letter-spacing:1.5px;text-transform:uppercase;color:#1d3557;}
  .az-section-remove{font-size:11px;color:#8fa3b8;cursor:pointer;background:none;border:none;font-family:'DM Sans',sans-serif;transition:color 0.15s;}
  .az-section-remove:hover{color:#e05c5c;}
  .az-section-block-body{padding:14px 16px;display:flex;flex-direction:column;gap:10px;}
  .az-add-section{width:100%;padding:11px;border:1.5px dashed #c5d0de;border-radius:10px;background:none;cursor:pointer;font-size:13px;font-weight:500;color:#1d3557;font-family:'DM Sans',sans-serif;transition:all 0.15s;display:flex;align-items:center;justify-content:center;gap:6px;}
  .az-add-section:hover{background:#f4f7fb;border-color:#1d3557;}
  .az-footer{padding:18px 32px 24px;border-top:1px solid #eef1f6;display:flex;gap:12px;justify-content:space-between;position:sticky;bottom:0;background:#fff;border-radius:0 0 16px 16px;}
  .az-btn-cancel{padding:10px 20px;border:1.5px solid #d4dbe6;border-radius:9px;background:none;cursor:pointer;font-size:13.5px;font-weight:500;color:#3d5166;font-family:'DM Sans',sans-serif;transition:all 0.15s;}
  .az-btn-cancel:hover{background:#f4f7fb;}
  .az-btn-send{padding:10px 24px;border:none;border-radius:9px;cursor:pointer;font-size:13.5px;font-weight:600;font-family:'DM Sans',sans-serif;transition:all 0.15s;display:flex;align-items:center;gap:7px;}
  .az-btn-send:disabled{opacity:0.6;cursor:not-allowed;}
  .az-btn-send-daily{background:#1d3557;color:#fff;}
  .az-btn-send-daily:hover:not(:disabled){background:#152844;box-shadow:0 4px 14px rgba(29,53,87,0.3);}
  .az-btn-send-weekly{background:#0e6b5e;color:#fff;}
  .az-btn-send-weekly:hover:not(:disabled){background:#0a5449;box-shadow:0 4px 14px rgba(14,107,94,0.3);}
  .az-upload-zone{border:2px dashed #c5d0de;border-radius:10px;padding:20px;text-align:center;cursor:pointer;transition:all 0.2s;background:#fafbfd;position:relative;}
  .az-upload-zone:hover{border-color:#1d3557;background:#f4f7fb;}
  .az-upload-zone input[type=file]{position:absolute;inset:0;opacity:0;cursor:pointer;width:100%;height:100%;}
  .az-upload-icon{font-size:28px;margin-bottom:6px;}
  .az-upload-text{font-size:13px;color:#3d5166;font-weight:500;}
  .az-upload-hint{font-size:11px;color:#8fa3b8;margin-top:3px;}
  .az-upload-preview{display:flex;align-items:center;gap:10px;padding:10px 12px;background:#f4f7fb;border:1.5px solid #e4eaf2;border-radius:9px;}
  .az-upload-preview img{width:48px;height:48px;object-fit:cover;border-radius:6px;border:1px solid #e4eaf2;}
  .az-upload-preview-name{flex:1;font-size:12.5px;color:#1d3557;font-weight:500;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}
  .az-upload-clear{background:none;border:none;cursor:pointer;color:#8fa3b8;font-size:16px;padding:2px 6px;border-radius:4px;transition:color 0.15s;}
  .az-upload-clear:hover{color:#e05c5c;}
  .az-toast{position:fixed;bottom:28px;right:28px;z-index:3000;padding:12px 20px;border-radius:10px;font-size:13.5px;font-weight:500;font-family:'DM Sans',sans-serif;box-shadow:0 8px 24px rgba(0,0,0,0.15);animation:azFadeIn 0.2s ease;display:flex;align-items:center;gap:8px;}
  .az-toast-success{background:#0a8f7a;color:#fff;}
  .az-toast-error{background:#dc2626;color:#fff;}
`;

function useToast() {
  const [toast, setToast] = useState(null);
  const show = (msg, type = "success") => {
    setToast({ msg, type });
    setTimeout(() => setToast(null), 3500);
  };
  const el = toast ? (
    <div className={`az-toast az-toast-${toast.type}`}>
      {toast.type === "success" ? "✅" : "❌"} {toast.msg}
    </div>
  ) : null;
  return { show, el };
}

function ImageUploadZone({ file, onChange }) {
  return file ? (
    <div className="az-upload-preview">
      <img src={URL.createObjectURL(file)} alt="preview" />
      <span className="az-upload-preview-name">{file.name}</span>
      <button className="az-upload-clear" type="button" onClick={() => onChange(null)}>✕</button>
    </div>
  ) : (
    <div className="az-upload-zone">
      <input type="file" accept="image/*" onChange={e => e.target.files[0] && onChange(e.target.files[0])} />
      <div className="az-upload-icon">🖼️</div>
      <div className="az-upload-text">Click or drag to upload chart image</div>
      <div className="az-upload-hint">PNG, JPG, SVG supported</div>
    </div>
  );
}

function SectionEditor({ sections, onUpdate, onAdd, onRemove }) {
  return (
    <div>
      <div className="az-section-divider">Content Sections</div>
      <div style={{marginTop:14, display:"flex", flexDirection:"column", gap:10}}>
        {sections.map((sec, i) => (
          <div key={i} className="az-section-block">
            <div className="az-section-block-header">
              <span className="az-section-block-title">Section {i + 1}</span>
              {sections.length > 1 && <button className="az-section-remove" onClick={() => onRemove(i)}>✕ Remove</button>}
            </div>
            <div className="az-section-block-body">
              <div className="az-field-row">
                <div className="az-field">
                  <label className="az-label">Heading <span>*</span></label>
                  <input className="az-input" value={sec.heading} onChange={e => onUpdate(i, "heading", e.target.value)} placeholder="e.g. Carbon Price" />
                </div>
                <div className="az-field">
                  <label className="az-label">Subtitle</label>
                  <input className="az-input" value={sec.subtitle} onChange={e => onUpdate(i, "subtitle", e.target.value)} placeholder="e.g. EUA December Contract" />
                </div>
              </div>
              <div className="az-field">
                <label className="az-label">Content <span>*</span></label>
                <textarea className="az-textarea" value={sec.content} onChange={e => onUpdate(i, "content", e.target.value)} placeholder="Write section body..." />
              </div>
            </div>
          </div>
        ))}
        <button className="az-add-section" onClick={onAdd}>+ Add Section</button>
      </div>
    </div>
  );
}

function RecipientsEditor({ recipients, defaultRecipients = [], onUpdate, onAdd, onRemove, onRemoveDefault, onReset }) {
  return (
    <div>
      <div className="az-section-divider" style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <span>Recipients</span>
        {onReset && (
          <button
            type="button"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onReset();
            }}
            style={{
              background: "none",
              border: "none",
              cursor: "pointer",
              fontSize: "11px",
              color: "#8fa3b8",
              fontWeight: 500,
              padding: "2px 6px",
              transition: "color 0.15s",
              lineHeight: 1
            }}
            onMouseEnter={e => e.currentTarget.style.color = "#e05c5c"}
            onMouseLeave={e => e.currentTarget.style.color = "#8fa3b8"}
          >
            🔄 Reset
          </button>
        )}
      </div>
      {defaultRecipients.length > 0 && (
        <div style={{
          display:"flex", flexWrap:"wrap", gap:"5px",
          padding:"10px", background:"#f8fafc",
          border:"1.5px solid #e4eaf2", borderRadius:"9px",
          marginBottom:"10px", maxHeight:"120px", overflowY:"auto",
          marginTop:"12px",
        }}>
          {defaultRecipients.map((email, i) => (
            <span key={i} style={{
              display:"inline-flex", alignItems:"center", gap:"4px",
              background:"#eef3f8", border:"1px solid #d4dbe6",
              borderRadius:"20px", padding:"2px 8px 2px 10px",
              fontSize:"11px", color:"#1d3557", whiteSpace:"nowrap",
            }}>
              {email}
              <button onClick={() => onRemoveDefault && onRemoveDefault(i)} style={{
                background:"none", border:"none", cursor:"pointer",
                color:"#8fa3b8", fontSize:"12px", padding:"0 0 0 2px",
                lineHeight:1, display:"flex", alignItems:"center",
              }}
              onMouseEnter={e => e.currentTarget.style.color="#e05c5c"}
              onMouseLeave={e => e.currentTarget.style.color="#8fa3b8"}
              >✕</button>
            </span>
          ))}
        </div>
      )}
      <div style={{marginTop:14}} className="az-recipients">
        {recipients.map((r, i) => (
          <div key={i} className="az-recipient-row">
            <input className="az-input" type="email" value={r} onChange={e => onUpdate(i, e.target.value)} placeholder={`client${i+1}@company.com`} />
            {recipients.length > 1 && <button type="button" className="az-remove-btn" onClick={() => onRemove(i)}>✕</button>}
          </div>
        ))}
        <button type="button" className="az-add-recipient" onClick={onAdd}>+ Add Recipient</button>
      </div>
    </div>
  );
}


const DEFAULT_RECIPIENTS = [
  "kiran@azolla.sg","aditya.s@azolla.sg","rob.phillips@amdlship.com",
  "rajnishkumar.k@synergyship.com","vangelis.rousos@tufton.com","technical@spmshipping.ae",
  "jupji.h@rafflestankers.com","Operations@womarpools.com","manav.c@azolla.sg",
  "subham.sinha@azolla.sg","subham.s@samudhramarine.co.in","Manoj.Kalra@abgtrading.com",
  "mbessone@scorpiogroup.net","operation@yasatanker.com","okl@mbshipbrokers.com",
  "jahj@mbshipbrokers.com","chartering@yasatanker.com","raja@mbshipbrokers.com",
  "jackie.smith@lomarshipping.com","Chukwuemeka.Okoye@nsml.com",
  "estela@tmcshipping.com","yetkin.fer@onn-shipping.com",
  "ls@falcon-maritime.com","bk@falcon-maritime.com","janani.m@azolla.sg",
  "Daniel.Miller@nlng.com","moses.obichie@NLNG.com","selin@gulnak.com",
  "emre@batinak.com","seher@gulport.com","technical@om-mar.com", "keiri@kitaurakaiun.co.jp","dai@kitaurakaiun.co.jp", "e_murakoshi@kitaurakaiun.co.jp", "kie_hyodo@kitaurakaiun.co.jp"
];

function DailyModal({ onClose, dispatch }) {
  const [fields, setFields] = useState({
    date: new Date().toLocaleDateString("en-GB", { day: "2-digit", month: "long", year: "numeric" }),
    eua_last_closed: "",
    eua_dec: "",
    uk_last_closed: "",
    uk_dec: "",
    chart_image: null,
    salutation: SALUTATION_DEFAULT,
    recipients: [],
    defaultRecipients: [...DEFAULT_RECIPIENTS],
    sections: [{ heading: "", subtitle: "", content: "" }],
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const { show, el: toastEl } = useToast();

  const set = (key, val) => setFields(f => ({ ...f, [key]: val }));
  const updateRecipient = (i, val) => { const r = [...fields.recipients]; r[i] = val; set("recipients", r); };
  const addRecipient    = () => set("recipients", [...fields.recipients, ""]);
  const removeRecipient = (i) => set("recipients", fields.recipients.filter((_, idx) => idx !== i));
  const removeDefault   = (i) => set("defaultRecipients", fields.defaultRecipients.filter((_, idx) => idx !== i));
  const updateSection   = (i, key, val) => { const s = [...fields.sections]; s[i] = { ...s[i], [key]: val }; set("sections", s); };
  const addSection      = () => set("sections", [...fields.sections, { heading: "", subtitle: "", content: "" }]);
  const removeSection   = (i) => set("sections", fields.sections.filter((_, idx) => idx !== i));
 const resetRecipients = () => {
  setFields(f => ({
    ...f,
    recipients: [],
    defaultRecipients: []
  }));
};

  const handleSend = async () => {
    setLoading(true);
    try {
      const fd = new FormData();
      fd.append("news_type",       "daily");
      fd.append("date",            fields.date);
      fd.append("eua_last_closed", fields.eua_last_closed);
      fd.append("eua_dec",         fields.eua_dec);
      fd.append("uk_last_closed",  fields.uk_last_closed);
      fd.append("uk_dec",          fields.uk_dec);
      fd.append("salutation",      fields.salutation);
      fd.append("closing",         fields.closing);
      if (fields.chart_image) fd.append("chart_image", fields.chart_image);
      const finalRecipients = [
        ...(fields.defaultRecipients || []),
        ...(fields.recipients || []).filter(r => r && r.trim())
      ];
      const uniqueRecipients = [...new Set(finalRecipients)].filter(Boolean);
      fd.append("recipients", JSON.stringify(uniqueRecipients));
      fd.append("section_data", JSON.stringify(fields.sections.filter(s => s.heading.trim())));

      const result = await dispatch(shareDailyEmail(fd));
      if (result?.payload && !result?.error) {
        show("Daily report sent successfully! ✉️", "success");
        setTimeout(() => onClose(), 1800);
      } else {
        const errMsg = result?.payload?.message || result?.payload?.detail || "Failed to send daily report.";
        show(errMsg, "error");
      }
    } catch (e) {
      console.error("Daily send error:", e);
      show("Request failed. Please try again.", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <style>{azCss}</style>
      {toastEl}
      <div className="az-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
        <div className="az-modal">

          <div className="az-modal-header">
            <div>
              <div className="az-modal-badge">📈 Daily</div>
              <div className="az-modal-title">Daily EUA Analysis</div>
              <div className="az-modal-subtitle">Compose and broadcast today's market update</div>
            </div>
            <button className="az-close" onClick={onClose}>✕</button>
          </div>

          <div className="az-modal-body">

            {/* Date */}
            <div className="az-field">
              <label className="az-label">Report Date <span>*</span></label>
              <input className="az-input" value={fields.date} onChange={e => set("date", e.target.value)} placeholder="12 March 2026" />
            </div>

            {/* Price Stats */}
            <div>
              <div className="az-section-divider">Price Stats</div>
              <div style={{marginTop:14}} className="az-price-grid">
                {[
                 { key:"eua_last_closed", label:"EUA Last Closed", currency:"EUR" },
{ key:"eua_dec",         label:"EUA Dec",         currency:"EUR" },
{ key:"uk_last_closed",  label:"UK Last Closed",  currency:"GBP" },
{ key:"uk_dec",          label:"UK Dec",           currency:"GBP" },
                ].map(({ key, label, currency }) => (
                  <div key={key} className="az-price-card">
                    <div className="az-price-card-label">{label}</div>
                    <input
                      value={fields[key]}
                      onChange={e => { set(key, e.target.value); setErrors(p => ({ ...p, [key]: "" })); }}
                      onBlur={() => {
                        if (!fields[key] && !["uk_last_closed", "uk_dec"].includes(key)) {
                          setErrors(p => ({ ...p, [key]: "Required"  })) ;
                        }
                      }}
                      placeholder="—"
                      className={errors[key] ? "input-error" : ""}
                    />
                    {errors[key] && <div className="az-price-error">{errors[key]}</div>}
                    <div className="az-price-eur">{currency}</div>
                  </div>
                ))}
              </div>
            </div>

            {/* Chart Image */}
            <div className="az-field">
              <label className="az-label">Chart Image</label>
              <ImageUploadZone file={fields.chart_image} onChange={f => set("chart_image", f)} />
            </div>

            {/* Content Sections */}
            <SectionEditor
              sections={fields.sections}
              onUpdate={updateSection}
              onAdd={addSection}
              onRemove={removeSection}
            />

            {/* Email Message */}
            <div>
              <div className="az-section-divider">Email Message</div>
              <div style={{marginTop:14, display:"flex", flexDirection:"column", gap:14}}>
                <div className="az-field">
                  <label className="az-label">Opening Salutation</label>
                  <textarea className="az-textarea" value={fields.salutation} onChange={e => set("salutation", e.target.value)} />
                </div>
                <div className="az-field">
                  <label className="az-label">Closing Message</label>
                  <textarea className="az-textarea" value={fields.closing} onChange={e => set("closing", e.target.value)} />
                </div>
              </div>
            </div>

            {/* Recipients */}
            <RecipientsEditor
              recipients={fields.recipients}
              defaultRecipients={fields.defaultRecipients}
              onUpdate={updateRecipient}
              onAdd={addRecipient}
              onRemove={removeRecipient}
              onRemoveDefault={removeDefault}
              onReset={resetRecipients}
            />

          </div>

          <div className="az-footer">
            <button className="az-btn-cancel" onClick={onClose}>Cancel</button>
            <button
              className="az-btn-send az-btn-send-daily"
              onClick={() => {
                Modal.confirm({
                  title: "Are you sure?",
                  content: "Do you want to share this update?",
                  okText: "Yes, Share",
                  cancelText: "Cancel",
                  onOk: handleSend,
                });
              }}
              disabled={loading}
            >
              {loading ? <>⏳ Sending…</> : <><span>📨</span> Share</>}
            </button>
          </div>

        </div>
      </div>
    </>
  );
}


function WeeklyModal({ onClose, dispatch }) {
  const now = new Date();
  const weekNum = Math.ceil(((now - new Date(now.getFullYear(), 0, 1)) / 86400000 + 1) / 7);

  const [fields, setFields] = useState({
    week_number:    String(weekNum),
    year:           String(now.getFullYear()),
    eua_week_high:   "",
    eua_week_low:    "",
    eua_week_closed: "",
    eua_week_dec:    "",
    chart_image:    null,
    salutation:     SALUTATION_DEFAULT,
    recipients: [],
    defaultRecipients: [...DEFAULT_RECIPIENTS],
    sections:       [{ heading: "", subtitle: "", content: "" }],
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const { show, el: toastEl } = useToast();

  const set = (key, val) => setFields(f => ({ ...f, [key]: val }));
  const updateRecipient = (i, val) => { const r = [...fields.recipients]; r[i] = val; set("recipients", r); };
  const addRecipient    = () => set("recipients", [...fields.recipients, ""]);
  const removeRecipient = (i) => set("recipients", fields.recipients.filter((_, idx) => idx !== i));
  const removeDefault   = (i) => set("defaultRecipients", fields.defaultRecipients.filter((_, idx) => idx !== i));
  const updateSection   = (i, key, val) => { const s = [...fields.sections]; s[i] = { ...s[i], [key]: val }; set("sections", s); };
  const addSection      = () => set("sections", [...fields.sections, { heading: "", subtitle: "", content: "" }]);
  const removeSection   = (i) => set("sections", fields.sections.filter((_, idx) => idx !== i));
 const resetRecipients = () => {
  setFields(f => ({
    ...f,
    recipients: [],
    defaultRecipients: []
  }));
};

  const handleSend = async (publish) => {
    setLoading(true);
    try {
      const fd = new FormData();
      fd.append("week_number",     fields.week_number);
      fd.append("year",            fields.year);
      fd.append("eua_week_high",   fields.eua_week_high);
      fd.append("eua_week_low",    fields.eua_week_low);
      fd.append("eua_week_closed", fields.eua_week_closed);
      fd.append("eua_week_dec",    fields.eua_week_dec);
      fd.append("salutation",      fields.salutation);
      fd.append("closing",         fields.closing);
      fd.append("publish_article", String(publish));
      if (fields.chart_image) fd.append("chart_image", fields.chart_image);
      fd.append("recipients",   JSON.stringify([...fields.defaultRecipients, ...fields.recipients.filter(r => r.trim())]));
      fd.append("section_data", JSON.stringify(fields.sections.filter(s => s.heading.trim())));

      const result = await dispatch(shareWeeklyEmail(fd));
      if (result?.payload && !result?.error) {
        show(publish ? "Weekly report shared & published! 📤" : "Weekly report shared! 📨", "success");
        setTimeout(() => onClose(), 1800);
      } else {
        const errMsg = result?.payload?.message || result?.payload?.detail || "Failed to send weekly report.";
        show(errMsg, "error");
      }
    } catch (e) {
      console.error("Weekly send error:", e);
      show("Request failed. Please try again.", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <style>{azCss}</style>
      {toastEl}
      <div className="az-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
        <div className="az-modal">

          <div className="az-modal-header">
            <div>
              <div className="az-modal-badge az-modal-badge-weekly">📊 Weekly</div>
              <div className="az-modal-title">Weekly Carbon Analysis</div>
              <div className="az-modal-subtitle">Compose and broadcast the weekly market report</div>
            </div>
            <button className="az-close" onClick={onClose}>✕</button>
          </div>

          <div className="az-modal-body">

            {/* Week + Year */}
            <div className="az-field-row">
              <div className="az-field">
                <label className="az-label">Week Number <span>*</span></label>
                <input className="az-input" value={fields.week_number} onChange={e => set("week_number", e.target.value)} placeholder="11" />
              </div>
              <div className="az-field">
                <label className="az-label">Year <span>*</span></label>
                <input className="az-input" value={fields.year} onChange={e => set("year", e.target.value)} placeholder="2026" />
              </div>
            </div>

            {/* Price Stats */}
            <div>
              <div className="az-section-divider">Price Stats <span style={{color:"#e05c5c"}}>*</span></div>
              <div style={{marginTop:14}} className="az-price-grid-3">
                {[
                  { key:"eua_week_high",   label:"EUA Week High" },
                  { key:"eua_week_low",    label:"EUA Week Low" },
                  { key:"eua_week_closed",  label:"EUA Last Closed" },
                  { key:"eua_week_dec",          label:"EUA Dec" },
                ].map(({ key, label }) => (
                  <div key={key} className="az-price-card">
                    <div className="az-price-card-label">{label}</div>
                    <input
                      value={fields[key]}
                      onChange={e => { set(key, e.target.value); setErrors(p => ({ ...p, [key]: "" })); }}
                      onBlur={() => {
                        if (!fields[key] && !["uk_last_closed", "uk_dec"].includes(key)) {
                          setErrors(p => ({ ...p, [key]: "Required" }));
                        }
                      }}
                      placeholder="—"
                      className={errors[key] ? "input-error" : ""}
                    />
                    {errors[key] && <div className="az-price-error">{errors[key]}</div>}
                    <div className="az-price-eur">EUR</div>
                  </div>
                ))}
              </div>
            </div>

            {/* Chart Image */}
            <div className="az-field">
              <label className="az-label">Chart Image</label>
              <ImageUploadZone file={fields.chart_image} onChange={f => set("chart_image", f)} />
            </div>

            {/* Content Sections */}
            <SectionEditor
              sections={fields.sections}
              onUpdate={updateSection}
              onAdd={addSection}
              onRemove={removeSection}
            />

            {/* Email Message */}
            <div>
              <div className="az-section-divider">Email Message</div>
              <div style={{marginTop:14, display:"flex", flexDirection:"column", gap:14}}>
                <div className="az-field">
                  <label className="az-label">Opening Salutation</label>
                  <textarea className="az-textarea" value={fields.salutation} onChange={e => set("salutation", e.target.value)} />
                </div>
                <div className="az-field">
                  <label className="az-label">Closing Message</label>
                  <textarea className="az-textarea" value={fields.closing} onChange={e => set("closing", e.target.value)} />
                </div>
              </div>
            </div>

            {/* Recipients */}
            <RecipientsEditor
              recipients={fields.recipients}
              defaultRecipients={fields.defaultRecipients}
              onUpdate={updateRecipient}
              onAdd={addRecipient}
              onRemove={removeRecipient}
              onRemoveDefault={removeDefault}
              onReset={resetRecipients}
            />

          </div>

          <div className="az-footer" >
            <button className="az-btn-cancel" onClick={onClose}>Cancel</button>
            <button
              className="az-btn-send az-btn-send-weekly"
              onClick={() => {
                Modal.confirm({
                  title: "Are you sure?",
                  content: "Do you want to share this update?",
                  okText: "Yes, Share",
                  cancelText: "Cancel",
                  onOk: () => handleSend(false),
                });
              }}
              disabled={loading}
            >
              {loading ? <>⏳</> : <><span>📨</span> Share</>}
            </button>
           
          </div>

        </div>
      </div>
    </>
  );
}


function FuelEUModal({ onClose, dispatch }) {
  const now = new Date();
  const [fields, setFields] = useState({
    month:              now.toLocaleString("en-GB", { month: "long" }),
    year:               String(now.getFullYear()),
    avg_surplus_price:  "",
    bid_ask_spread:     "",
    market_commentary:  "",
    supply:             "",
    demand:             "",
    pooling_deadline:   "",
    banking_deadline:   "",
    outlook:            "",
    chart_image:        null,
    salutation:         SALUTATION_DEFAULT,
    recipients:         [],
    defaultRecipients:  [...FUEL_EU_DEFAULT_RECIPIENTS],
  });
  const [loading, setLoading]   = useState(false);
  const { show, el: toastEl }   = useToast();

  const set             = (key, val) => setFields(f => ({ ...f, [key]: val }));
  const updateRecipient = (i, val)   => { const r = [...fields.recipients]; r[i] = val; set("recipients", r); };
  const addRecipient    = ()         => set("recipients", [...fields.recipients, ""]);
  const removeRecipient = (i)        => set("recipients", fields.recipients.filter((_, idx) => idx !== i));
  const removeDefault   = (i)        => set("defaultRecipients", fields.defaultRecipients.filter((_, idx) => idx !== i));
  const resetRecipients = () => {
  setFields(f => ({
    ...f,
    recipients: [],
    defaultRecipients: []
  }));
};

  const handleSend = async () => {
    setLoading(true);
    try {
      const fd = new FormData();
      fd.append("month",              fields.month);
      fd.append("year",               fields.year);
      fd.append("avg_surplus_price",  fields.avg_surplus_price);
      fd.append("bid_ask_spread",     fields.bid_ask_spread);
      fd.append("market_commentary",  fields.market_commentary);
      fd.append("supply",             fields.supply);
      fd.append("demand",             fields.demand);
      fd.append("pooling_deadline",   fields.pooling_deadline);
      fd.append("banking_deadline",   fields.banking_deadline);
      fd.append("outlook",            fields.outlook);
      fd.append("salutation",         fields.salutation);
      if (fields.chart_image) fd.append("chart_image", fields.chart_image);

      const allRecipients = [
        ...(fields.defaultRecipients || []),
        ...(fields.recipients || []).filter(r => r && r.trim()),
      ];
      fd.append("recipients", JSON.stringify([...new Set(allRecipients)].filter(Boolean)));

      const result = await dispatch(shareFuelEuEmail(fd));
      if (result?.payload && !result?.error) {
        show("Fuel EU report sent successfully! ⛽", "success");
        setTimeout(() => onClose(), 1800);
      } else {
        const errMsg = result?.payload?.message || result?.payload?.detail || "Failed to send Fuel EU report.";
        show(errMsg, "error");
      }
    } catch (e) {
      console.error("FuelEU send error:", e);
      show("Request failed. Please try again.", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <style>{azCss}</style>
      <style>{`.az-modal-badge-fueleu{color:#7b3f00;background:#fdf3e7;} .az-btn-send-fueleu{background:#7b3f00;color:#fff;} .az-btn-send-fueleu:hover:not(:disabled){background:#5c2e00;box-shadow:0 4px 14px rgba(123,63,0,0.3);}`}</style>
      {toastEl}
      <div className="az-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
        <div className="az-modal">

          <div className="az-modal-header">
            <div>
              <div className="az-modal-badge az-modal-badge-fueleu">⛽ Fuel EU</div>
              <div className="az-modal-title">Fuel EU Analysis</div>
              <div className="az-modal-subtitle">Compose and broadcast the monthly Fuel EU market update</div>
            </div>
            <button className="az-close" onClick={onClose}>✕</button>
          </div>

          <div className="az-modal-body">

            {/* Month + Year */}
            <div className="az-field-row">
              <div className="az-field">
                <label className="az-label">Month <span>*</span></label>
                <input className="az-input" value={fields.month} onChange={e => set("month", e.target.value)} placeholder="e.g. May" />
              </div>
              <div className="az-field">
                <label className="az-label">Year <span>*</span></label>
                <input className="az-input" value={fields.year} onChange={e => set("year", e.target.value)} placeholder="2026" />
              </div>
            </div>

            {/* Price Cards */}
            <div>
              <div className="az-section-divider">Price Stats</div>
              <div style={{marginTop:14, display:"grid", gridTemplateColumns:"1fr 1fr", gap:12}}>
                {[
                  { key:"avg_surplus_price", label:"Avg Surplus Price", unit:"€/tCO₂e" },
                  { key:"bid_ask_spread",    label:"Bid-Ask Spread",    unit:"€/tCO₂e" },
                ].map(({ key, label, unit }) => (
                  <div key={key} className="az-price-card">
                    <div className="az-price-card-label">{label}</div>
                    <input value={fields[key]} onChange={e => set(key, e.target.value)} placeholder="0.00" />
                    <div className="az-price-eur">{unit}</div>
                  </div>
                ))}
              </div>
            </div>

            {/* Chart Image */}
            <div className="az-field">
              <label className="az-label">Chart Image</label>
              <ImageUploadZone file={fields.chart_image} onChange={f => set("chart_image", f)} />
            </div>

            {/* Market Commentary */}
            <div className="az-field">
              <label className="az-label">Market Commentary</label>
              <textarea className="az-textarea" rows={4} value={fields.market_commentary}
                onChange={e => set("market_commentary", e.target.value)}
                placeholder="2–3 sentences on key price movement and primary driver..." />
            </div>

            {/* Supply & Demand */}
            <div>
              <div className="az-section-divider">Supply &amp; Demand</div>
              <div style={{marginTop:14, display:"flex", flexDirection:"column", gap:12}}>
                <div className="az-field">
                  <label className="az-label">Supply</label>
                  <textarea className="az-textarea" rows={3} value={fields.supply}
                    onChange={e => set("supply", e.target.value)}
                    placeholder="e.g. Bio-LNG and liner segments primary source; new providers entering market." />
                </div>
                <div className="az-field">
                  <label className="az-label">Demand</label>
                  <textarea className="az-textarea" rows={3} value={fields.demand}
                    onChange={e => set("demand", e.target.value)}
                    placeholder="e.g. Late-movers accelerating; typical vessel needs ~150–200 tCO₂e." />
                </div>
              </div>
            </div>

            {/* Key Compliance Dates */}
            <div>
              <div className="az-section-divider">Key Compliance Dates</div>
              <div style={{marginTop:14}} className="az-field-row">
                <div className="az-field">
                  <label className="az-label">Pooling Agreement Deadline</label>
                  <input className="az-input" value={fields.pooling_deadline}
                    onChange={e => set("pooling_deadline", e.target.value)} placeholder="15 April 2027" />
                </div>
                <div className="az-field">
                  <label className="az-label">Banking of Surplus Deadline</label>
                  <input className="az-input" value={fields.banking_deadline}
                    onChange={e => set("banking_deadline", e.target.value)} placeholder="30 June 2026" />
                </div>
              </div>
            </div>

            {/* Outlook */}
            <div className="az-field">
              <label className="az-label">Outlook</label>
              <textarea className="az-textarea" rows={3} value={fields.outlook}
                onChange={e => set("outlook", e.target.value)}
                placeholder="2 sentences max on expected price direction and recommended action..." />
            </div>

            {/* Email Message */}
            <div>
              <div className="az-section-divider">Email Message</div>
              <div style={{marginTop:14, display:"flex", flexDirection:"column", gap:14}}>
                <div className="az-field">
                  <label className="az-label">Opening Salutation</label>
                  <textarea className="az-textarea" value={fields.salutation} onChange={e => set("salutation", e.target.value)} />
                </div>
              </div>
            </div>

            {/* Recipients */}
            <RecipientsEditor
              recipients={fields.recipients}
              defaultRecipients={fields.defaultRecipients}
              onUpdate={updateRecipient}
              onAdd={addRecipient}
              onRemove={removeRecipient}
              onRemoveDefault={removeDefault}
              onReset={resetRecipients}
            />

          </div>

          <div className="az-footer">
            <button className="az-btn-cancel" onClick={onClose}>Cancel</button>
            <button
              className="az-btn-send az-btn-send-fueleu"
              onClick={() => {
                Modal.confirm({
                  title: "Are you sure?",
                  content: "Do you want to send this Fuel EU report?",
                  okText: "Yes, Send",
                  cancelText: "Cancel",
                  onOk: handleSend,
                });
              }}
              disabled={loading}
            >
              {loading ? <>⏳ Sending…</> : <><span>📨</span> Share</>}
            </button>
          </div>

        </div>
      </div>
    </>
  );
}


export default NewsCard;
